import { DEBUG_MODE_ENABLED } from '@constants';

const trackCustom = (event, customData = {}) => {
  const data = {
    currency: 'USD',
    value: 0.0,
    ...customData,
  };

  if (window.fbq) {
    // eslint-disable-next-line no-undef
    window.fbq('trackCustom', event, data);
  }

  if (DEBUG_MODE_ENABLED) {
    console.info(`[FacebookPixel] fbq('trackCustom', ${event});`, data);
  }
};

const track = (event, customData = {}) => {
  const data = {
    currency: 'USD',
    value: 0.0,
    ...customData,
  };

  if (window.fbq) {
    // eslint-disable-next-line no-undef
    window.fbq('track', event, data);
  }

  if (DEBUG_MODE_ENABLED) {
    console.info(`[FacebookPixel] fbq('track', ${event});`, data);
  }
};

export const fbPixelInit = () => {
  try {
    const pixelId = process.env.FACEBOOK_PIXEL_ID;

    if (typeof window.fbq !== 'undefined' || !pixelId) {
      return;
    }

    /* eslint-disable */
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */

    fbq('init', pixelId); // eslint-disable-line no-undef
    fbq('track', 'PageView'); // eslint-disable-line no-undef
  } catch (error) {
    console.warn('Facebook pixel initialization failed: %o', error);
  }
};

/**
 * operationType [BUY, SELL]
 */
export const trackFunds = (operationType, amount) => {
  const event = `Request${operationType === 'BUY' ? 'Add' : 'Withdraw'}Funds`;
  const data = {
    value: amount,
  };

  trackCustom(event, data);
};

/**
 * operationType [BUY, SELL]
 */
export const trackOperationCompleted = (operationType, operationId, amount) => {
  const event = `Complete${operationType === 'BUY' ? 'Add' : 'Withdraw'}Funds`;
  const data = {
    transaction_id: operationId,
    value: amount,
  };

  trackCustom(event, data);
};

export const trackFirstTransactionCompleted = (operationId, amount) => {
  const event = 'FirstCompleteTransaction';
  const data = {
    transaction_id: operationId,
    value: amount,
  };

  trackCustom(event, data);
};

export const trackSignup = () => {
  const event = 'CompleteRegistration';

  track(event);
};

export const trackProfileCompleted = () => {
  const event = 'CompleteProfile';

  trackCustom(event);
};

export const trackReferralInvite = () => {
  const event = 'InviteFriend';

  trackCustom(event);
};
